"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupWindow = void 0;
var react_1 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var cookieNamespace = 'beam.tearOff.window';
var cookies = new universal_cookie_1.default();
function PopupWindow(_a) {
    var id = _a.id, _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c, _d = _a.onReady, onReady = _d === void 0 ? function () { } : _d, onError = _a.onError, _e = _a.useParentUrl, useParentUrl = _e === void 0 ? false : _e, _f = _a.templateURL, templateURL = _f === void 0 ? '' : _f, _g = _a.willObserveMutations, willObserveMutations = _g === void 0 ? true : _g, _h = _a.errorText, errorText = _h === void 0 ? '' : _h, _j = _a.directories, directories = _j === void 0 ? false : _j, _k = _a.location, location = _k === void 0 ? false : _k, _l = _a.menubar, menubar = _l === void 0 ? false : _l, _m = _a.resizable, resizable = _m === void 0 ? true : _m, _o = _a.scrollbars, scrollbars = _o === void 0 ? false : _o, _p = _a.status, status = _p === void 0 ? false : _p, _q = _a.titlebar, titlebar = _q === void 0 ? false : _q, width = _a.width, height = _a.height, left = _a.left, top = _a.top, children = _a.children;
    var _r = (0, react_1.useState)(null), containerEl = _r[0], setContainerEl = _r[1];
    var getCookieId = function () { return "".concat(cookieNamespace, ".").concat(id); };
    /**
     * Check to see if this window has cookies set
     */
    (0, react_1.useEffect)(function () {
        var getPopupUrl = function () {
            if (useParentUrl) {
                return window.location; // TODO: delete if confirmed as unused
            }
            else if (templateURL) {
                return templateURL;
            }
            else {
                return '';
            }
        };
        var url = getPopupUrl();
        var windowId = window.name;
        var extWindow = id !== windowId
            ? window.open(url, '', restorePosition(window))
            : null;
        if (extWindow) {
            var initializeWindowFn = function () {
                extWindow.name = id;
                extWindow.document.title = title;
                extWindow.document.body.innerHTML = '';
                extWindow.document.body.style.margin = '0';
                // Remove stylesheets from head on load
                // Wierd function call due to IE compatibility
                Array.prototype.forEach.call(extWindow.document.head.querySelectorAll('style,link[type="text/css"],link[rel="stylesheet"]'), function (el) { return extWindow.document.head.removeChild(el); });
                // create element off of extWindow for IE11 and Edge
                var container = extWindow.document.createElement('div');
                container.style.height = '100vh';
                extWindow.document.body.appendChild(container);
                setContainerEl(container);
                if (extWindow.document.readyState === 'complete') {
                    copyStyles(document, extWindow.document);
                    onReady();
                }
                else {
                    (function (loadFn) {
                        return extWindow.document.addEventListener
                            ? extWindow.document.addEventListener('DOMContentLoaded', loadFn)
                            : extWindow.document.attachEvent('onDOMContentLoaded', loadFn);
                    })(function () {
                        copyStyles(document, extWindow.document);
                        onReady();
                    });
                }
                // FIX ME: Initial call to window.open creates the child window in a
                // larger size than requested. This code adjusted the window size
                // back to the requested dimensions.
                var position = getPosition(extWindow);
                extWindow.resizeTo(position.width, position.height);
            };
            useParentUrl
                ? initializeWindowFn()
                : extWindow.addEventListener('load', initializeWindowFn);
            if (useParentUrl || url === '') {
                // Blank window will not fire an onload event
                initializeWindowFn();
            }
            else if (extWindow.addEventListener) {
                extWindow.addEventListener('load', initializeWindowFn);
            }
            else {
                extWindow.attachEvent('onload', initializeWindowFn);
            }
            //First argument is the event
            var extWindowUnload_1 = function (_, wasClosedByParent) {
                if (wasClosedByParent === void 0) { wasClosedByParent = false; }
                savePosition(extWindow);
                onClose(_, wasClosedByParent);
            };
            var windowUnload = function () {
                extWindow.removeEventListener
                    ? extWindow.removeEventListener('beforeunload', extWindowUnload_1)
                    : extWindow.detachEvent('onbeforeunload', extWindowUnload_1);
                extWindowUnload_1(null, true);
                extWindow.close();
            };
            (function (unloadFn) {
                return extWindow.addEventListener
                    ? extWindow.addEventListener('beforeunload', unloadFn)
                    : extWindow.attachEvent('onbeforeunload', unloadFn);
            })(extWindowUnload_1);
            (function (unloadFn) {
                return window.addEventListener
                    ? window.addEventListener('beforeunload', unloadFn)
                    : window.attachEvent('onbeforeunload', unloadFn);
            })(windowUnload);
        }
        else {
            // Popups disabeld
            onError(new Error(errorText));
        }
        var observer = willObserveMutations
            ? new MutationObserver(function () {
                copyStyles(document, extWindow.document);
            })
            : null;
        observer === null || observer === void 0 ? void 0 : observer.observe(document.head, { subtree: true, childList: true });
        return function () {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            extWindow === null || extWindow === void 0 ? void 0 : extWindow.close();
        };
    }, []);
    var restorePosition = function (win) {
        var position = getPosition(win);
        var userOptions = {
            directories: directories,
            location: location,
            menubar: menubar,
            resizable: resizable,
            scrollbars: scrollbars,
            status: status,
            titlebar: titlebar,
            width: width !== null && width !== void 0 ? width : position.width,
            height: height !== null && height !== void 0 ? height : position.height,
            left: left !== null && left !== void 0 ? left : position.left,
            top: top !== null && top !== void 0 ? top : position.top,
        };
        return makeWindowOptionsString(userOptions);
    };
    var getPosition = function (win) {
        var position = cookies.get(getCookieId());
        if (typeof position === 'undefined' ||
            position === null ||
            position.width === 0 ||
            position.height === 0) {
            var width_1 = win.screen.availWidth;
            var height_1 = win.screen.availHeight;
            position = {
                width: width_1 / 2,
                height: height_1 / 2,
                left: width_1 / 2 - width_1 / 4,
                top: height_1 / 2 - height_1 / 4,
            };
        }
        return position;
    };
    var savePosition = function (win) {
        var position = {
            width: win.outerWidth,
            height: win.outerHeight,
            left: win.screenX || win.screenLeft,
            top: win.screenY || win.screenTop,
        };
        cookies.set(getCookieId(), position, {
            path: '/',
            expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        });
    };
    return containerEl
        ? react_dom_1.default.createPortal(children, containerEl)
        : null;
}
exports.PopupWindow = PopupWindow;
function makeWindowOptionsString(options) {
    return Object.entries(options)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        var valString = value;
        if (value === true) {
            valString = 'yes';
        }
        else if (value === false) {
            valString = 'no';
        }
        return "".concat(key, "=").concat(valString);
    })
        .join(',');
}
// Adapted from https://hackernoon.com/using-a-react-16-portal-to-do-something-cool-2a2d627b0202
function copyStyles(sourceDoc, targetDoc) {
    Array.from(sourceDoc.styleSheets).forEach(function (styleSheet) {
        try {
            if (styleSheet.cssRules) {
                // for <style> elements
                var newStyleEl_1 = targetDoc.createElement('style');
                Array.from(styleSheet.cssRules).forEach(function (cssRule) {
                    // write the text of each rule into the body of the style element
                    newStyleEl_1.appendChild(targetDoc.createTextNode(cssRule.cssText));
                });
                targetDoc.head.appendChild(newStyleEl_1);
            }
            else if (styleSheet.href) {
                // for <link> elements loading CSS from a URL
                var newLinkEl = targetDoc.createElement('link');
                newLinkEl.rel = 'stylesheet';
                newLinkEl.href = styleSheet.href;
                targetDoc.head.appendChild(newLinkEl);
            }
        }
        catch (e) {
            // Ignore cross-origin stylesheets for now
        }
    });
}
exports.default = PopupWindow;
//# sourceMappingURL=index.js.map